export default __webpack_public_path__ + "static/media/background.58dab82a.png";